import { instance, TenantService } from 'seismic-common';

const initialSeismicCommon = () => {
    // This is using for handle subdomain problem - https://seismic.atlassian.net/wiki/spaces/FEC/pages/3044446130/Tenant+Subdomain+Solution#Migration
    if (window.seismicSDSResponse) {
        window.appDatas = window.appDatas || {}; // workaround solution: fixed seismic-common js error, should be removed after ticket FEARCH-300 done, and integrate the new seismic-common package version
        window.appDatas = {
            ...window.appDatas,
            // There is an issue here https://seismic.atlassian.net/browse/FEARCH-1232
            // https://github.com/seismic/web-common-assets/pull/328
            featureToggles: []
        };
        window.appDatas.sdsAddresses = Object.entries(window.seismicSDSResponse.serviceAddress).map(entry => ({
            Key: entry[0],
            Value: entry[1]
        }));
        const subdomain = window.seismicSDSResponse.tenantSubdomain;
        const tenantInfo = {
            environment: window.seismicSDSResponse.environment,
            tenantName: window.seismicSDSResponse.tenantName,
            tenantSubdomain: subdomain,
            tenantUniqueId: window.seismicSDSResponse.tenantUniqueId
        };
        instance.getService(TenantService).initTenantInfoByCache(tenantInfo);
        window.ROOT_URL = (window.seismicSDSResponse.serviceAddress && window.seismicSDSResponse.serviceAddress.liveshare) || '';
    }
};

export default initialSeismicCommon;
